import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import "flatpickr/dist/themes/material_blue.css";
import { withRouter } from "react-router-dom";
import CustomSelect from "../../Common/CustomSelect";
import CustomMiniLoader from "../../CustomMiniLoader/CustomMiniLoader";

const PaymentsForm = ({
  data,
  clients,
  clientId,
  history,
  loading,
  updatePayment,
  permissions,
}) => {
  const [selectedClient, setSelectedClient] = useState({});

  useEffect(() => {
    clients.map(i => {
      if (i.value == clientId) {
        return setSelectedClient(i);
      }
    });
  }, [clients]);

  const onSubmitForm = (e, errors, params) => {
    if (errors?.length === 0) {
      let data = {
        ...params,
        client: params.client.value,
      };
      updatePayment(data);
    }
  };

  return (
    <AvForm className="needs-validation" onSubmit={onSubmitForm}>
      <Row className="d-flex justify-content-center">
        <Col lg={9}>
          <Col sm={12}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Account information</CardTitle>
                <Row className="align-items-center">
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Client:</Label>
                      <CustomSelect
                        name="client"
                        options={clients || []}
                        placeholder="Select client..."
                        value={selectedClient}
                        onChange={setSelectedClient}
                        classNamePrefix="select2-selection"
                        errorMessage="Client is required!"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">
                        Account status:
                      </Label>
                      <AvField
                        name={`account_status`}
                        placeholder="Account status..."
                        type="text"
                        defaultValue={data.account_status || ""}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Account type:</Label>
                      <AvField
                        name={`account_type`}
                        placeholder="Account type..."
                        defaultValue={data.account_type || ""}
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <label htmlFor="">Account name:</label>
                      <AvField
                        name={`account_name`}
                        placeholder="Account name..."
                        defaultValue={data.account_name || ""}
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <label htmlFor="">Account number:</label>
                      <AvField
                        name={`account_number`}
                        placeholder="Account name..."
                        defaultValue={data.account_number || ""}
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm={12}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Bank information</CardTitle>
                <Row className="align-items-center">
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Bank name:</Label>
                      <AvField
                        name={`bank_name`}
                        placeholder="Bank name..."
                        defaultValue={data.bank_name || ""}
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">
                        Bank reference:
                      </Label>
                      <AvField
                        name={`bank_reference`}
                        defaultValue={data.bank_reference || ""}
                        placeholder="Bank reference..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Currency:</Label>
                      <AvField
                        name={`currency`}
                        defaultValue={data.currency || ""}
                        placeholder="Currency..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <label htmlFor="">Location:</label>
                      <AvField
                        name={`location`}
                        defaultValue={data.location || ""}
                        placeholder="Location..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <label htmlFor="">BIC:</label>
                      <AvField
                        name={`bic`}
                        defaultValue={data.bic || ""}
                        placeholder="BIC..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <label htmlFor="">IBAN:</label>
                      <AvField
                        name={`iban`}
                        defaultValue={data.iban || ""}
                        placeholder="IBAN..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm={12}>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">Other information</CardTitle>
                <Row className="align-items-center">
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Narrative:</Label>
                      <AvField
                        name={`narrative`}
                        placeholder="Narrative..."
                        defaultValue={data.narrative || ""}
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">
                        Customer reference:
                      </Label>
                      <AvField
                        name={`customer_reference`}
                        defaultValue={data.customer_reference || ""}
                        placeholder="Customer reference..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">TRN type:</Label>
                      <AvField
                        name={`trn_type`}
                        defaultValue={data.trn_type || ""}
                        placeholder="TRN type..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Credit amount:</Label>
                      <AvField
                        name={`credit_amount`}
                        defaultValue={data.credit_amount || ""}
                        placeholder="Credit amount..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Debit amount:</Label>
                      <AvField
                        name={`debit_amount`}
                        defaultValue={data.debit_amount || ""}
                        placeholder="Debit amount..."
                        type="text"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Time:</Label>

                      <AvField
                        name={`time`}
                        defaultValue={data.time || ""}
                        placeholder="Time..."
                        type="time"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Post date:</Label>
                      <AvField
                        name={`post_date`}
                        defaultValue={data.post_date.replace("Z", "") || ""}
                        placeholder="Post date..."
                        type="datetime-local"
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Row>
            <Col className="col-12 mb-5 mt-2 text-end">
              <ButtonContainer>
                {loading ? (
                  <div>
                    <CustomMiniLoader
                      className="fade-in-custom-animate"
                      style={{ minWidth: "143px" }}
                      status
                      text="Please wait"
                    />
                  </div>
                ) : (
                  <div>
                    <button
                      type="button"
                      onClick={() =>
                        history.push(`/clients/${clientId}#payments`)
                      }
                      className="btn btn-outline-primary save-user fade-in-custom-animate"
                    >
                      Back to client
                    </button>
                    {permissions?.["change_bankuploadingmodel"] && (
                      <button
                        type="submit"
                        className="btn btn-success save-user fade-in-custom-animate ms-3"
                      >
                        Save changes
                      </button>
                    )}
                  </div>
                )}
              </ButtonContainer>
            </Col>
          </Row>
        </Col>
      </Row>
    </AvForm>
  );
};

const ButtonContainer = styled.div`
  text-align: right !important;
`;

PaymentsForm.propTypes = {
  loading: PropTypes.bool,
  updatePayment: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clients: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired,
  history: PropTypes.any.isRequired,
  permissions: PropTypes.any,
};

export default withRouter(PaymentsForm);
